import axios from "axios";
import { Street } from "../../../mixins/services/route";
import { isNeositek } from "../../../utils/neositek";

const client = axios.create({
  baseURL: "https://tools.2kbo.com:7102/",
});

export type ResolveAddressResponse = {
  street: Street;
  portal: number;
};

function getStore() {
  return (window as any).store;
}

function getFlavour() {
  return isNeositek() ? "neositek" : "kbo";
}

export const resolveAddress = async (address: string, wgId: number, centralId: number) => {
  const wgName = getStore().getters["app/workgroups"].find((wg: any) => wg.id === wgId)?.ref;
  return await client
    .post<ResolveAddressResponse | null>(
      `/api/v1/ai/streets/${getFlavour()}/${wgName}/${wgId}/${centralId}/resolve`,
      {
        street: address,
      }
    )
    .then((res) => res.data);
};
